appSocial.component('leaderPortfolio', {
    templateUrl: 'widgets/leader-detail/components/leader-portfolio/LeaderPortfolioComponent.html',
    bindings: {
        trader: '<'
    },
    controller: [
        '$ionicLoading',
        'SocialUserService',
        'SocialLocaleService',
        'SocialUtils',
        'SocialTypes',
        'SocialAPIService',
        'SocialThemeService',
        'SocialConstants',
        'Trade',
        'moment',
        class LeaderPortfolioComponent {
            constructor(
                $ionicLoading,
                SocialUserService,
                SocialLocaleService,
                SocialUtils,
                SocialTypes,
                SocialAPIService,
                SocialThemeService,
                SocialConstants,
                Trade,
                moment
            ) {

                /**
                 * @type {SocialUserService}
                 */
                this.userService = SocialUserService;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialAPIService}
                 */
                this.api = SocialAPIService;

                /**
                 * @type {SocialThemeService}
                 */
                this.themeService = SocialThemeService;

                this.types = SocialTypes;

                this.moment = moment;

                this.translation = SocialLocaleService.translation;

                this.constants = SocialConstants;

                this.$ionicLoading = $ionicLoading;

                const {WidgetMode, WidgetView, FieldOperation, Op} = this.types;

                this.tradeFilters = {
                    'open': {
                        fields: [
                            {
                                name: 'close_time',
                                op: FieldOperation.Match,
                                value: 0,
                                next: Op.And
                            }
                        ],
                        order: [],
                        page: 0,
                        limit: 5000
                    },
                    'closed': {
                        fields: [
                            {
                                name: 'close_time',
                                op: FieldOperation.GreaterThan,
                                value: 0,
                                next: Op.And
                            }
                        ],
                        order: [],
                        page: 0,
                        limit: 5000
                    }
                };

                this.widgetMode = WidgetMode.Closed;
                this.widgetView = WidgetView.Chart;

                this.summary = {
                    from: null,
                    to: null,
                    profitable: 0,
                    profit: 0
                };

                this.trades = [];

                this.filterMarkets = _.concat([{id: 'all', label: 'all'}], SocialConstants.markets);
                // this.filterRanges = _.concat([{id: 'all', label: 'all'}], SocialConstants.dateRanges);
                this.filterRanges = SocialConstants.dateRanges;

                this.defaultRange = 2; // last month

                this.market = this.filterMarkets[0];
                this.range = this.filterRanges[this.defaultRange];

                this.assetsPercentage = this.createAssetsPercentage([]);

                // TODO find a way to import class
                this.tradeFactory = (data) => new Trade(data);
            }

            $onInit() {
                this.switchTrades();
            }

            $onChanges(changes) {
                //console.log('trader changes', this.trader)
            }

            $onDestroy() {
            }

            setMode(mode) {
                this.widgetMode = mode;
                this.switchTrades(this.widgetMode);
            }

            setView(view) {
                this.widgetView = view;
                if (view === 'chart') {
                    this.market = this.filterMarkets[0];
                    this.switchTrades(this.widgetMode)
                }
            }

            getTrades(mode) {
                const {FieldOperation, Op, Dir} = this.types;

                const tradesFilter = _.merge({}, this.tradeFilters[mode]);

                if (this.market && this.market.id !== 'all') {
                    const market = {
                        name: 'market',
                        op: FieldOperation.Match,
                        value: this.market.id,
                        next: Op.Or
                    };
                    tradesFilter.fields = _.concat(tradesFilter.fields, [market]);
                }

                tradesFilter.dateRange = this.range ? this.range.id : 'all';
                tradesFilter.order = [
                    {
                        name: 'open_time',
                        dir: Dir.Desc
                    }

                ];

                const query = this.utils.createQuery(tradesFilter);

                const request = _.merge({_url: '/' + this.trader.id}, query);

                return this.api.request.getTrades(request)
                    .then((response) => response.trades.map(item => this.tradeFactory(item)));
            }

            createAssetsPercentage(trades) {
                const markets = this.constants.markets.map(market => {
                    //find trades by markets
                    const tradesByMarket = _.filter(trades, {market: market.id});
                    const percentage = tradesByMarket.length * 100 / trades.length;
                    return {
                        name: market.id.toLowerCase(),
                        percentage: trades.length ? percentage : 0,
                    };
                });
                return _.orderBy(markets, ['percentage'], 'desc');
            }

            switchTrades() {
                const {WidgetMode} = this.types;

                //reset range for open trades mode
                if (this.widgetMode === WidgetMode.Open) {
                    this.range = this.filterRanges[this.defaultRange];
                }

                // this.status = WidgetStatus.Loading;
                // this.$ionicLoading.show();

                this.getTrades(this.widgetMode)
                    .then(trades => {
                        this.trades = trades;
                        this.assetsPercentage = this.createAssetsPercentage(this.trades);
                        // this.pieChartOptions = this.createChart(this.assetsPercentage);

                        // this.filterTradesForSelect();
                        this.updateSummary();

                        // this.status = this.trades.length ? WidgetStatus.Success : WidgetStatus.Empty;
                        // console.log(this.assetsPercentage)
                        // this.$ionicLoading.hide();
                    })
                    .catch(err => {
                        this.updateSummary();
                        // this.status = WidgetStatus.Fail;
                        console.warn(err);
                        // this.$ionicLoading.hide();
                        throw err;
                    });

            }

            updateSummary() {
                const {DateRange} = this.types;
                const [from, to] = this.utils.dateTagToRange(this.range ? (this.range.id) : DateRange.All);
                this.summary.from = from;
                this.summary.to = to;
                this.summary.profit = this.trades.reduce((acc, cur) => acc + cur.change, 0);
                this.summary.profitable = this.trades.length
                    ? this.trades.filter(trade => trade.profit > 0).length / this.trades.length * 100
                    : 0;
            }


        }]
})
